import { Accessor, Component, Show } from "solid-js";
import { MultiProgress } from "./multi-progress";

type Props = {
    count: Accessor<number>;
    min: number;
    max: number;
    entity: string;
    entities?: string;
}

export const MultiProgressPanel : Component<Props> = ({ count, min, max, entity, entities }) => {
    const quantity = (x: number) => x == 1 ? entity : (entities || (entity + "s"));
    return (
        <>
            <div>
                <MultiProgress value={count} min={min} max={max} />
            </div>
            <div style="font-size: 1.25em;">
                <b style="color: green;">{count()}</b> {quantity(count())} added
            </div>
            <Show when={min - count() >= 0}>
                <div style="font-size: 1.25em;">
                    <b style="color: red;">{min - count()}</b> more {quantity(min - count())} required
                </div>
            </Show>
            <div style="font-size: 1.25em;">
                <b style="color: orange;">{max - count()}</b> more {quantity(max - count())} available
            </div>
        </>
    );
}